import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import TestimonialCard from "../TestimonialCard";

interface Testimonial {
  id: number;
  name: string;
  role?: string;
  message: string;
  image?: string;
}

interface MicrositeTestimonialPreviewProps {
  testimonials: Testimonial[];
  color?: string;
}

const MicrositeTestimonialPreview: React.FC<MicrositeTestimonialPreviewProps> = ({
  testimonials,
  color = "#885ABB",
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(1);

  // Auto-slide every 5 seconds
  useEffect(() => {
    if (testimonials.length === 0) return;
    const interval = setInterval(() => {
      setDirection(1);
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  const handleDotClick = (index: number) => {
    setDirection(index > currentIndex ? 1 : -1);
    setCurrentIndex(index);
  };

  if (testimonials.length === 0)
    return (
      <p className="text-gray-500 text-center italic py-10">No testimonials yet.</p>
    );

  return (
    <div  className="py-6 text-center">
    <div className="rounded-xl p-8 flex flex-col items-center justify-center shadow-sm mx-auto max-w-4xl font-serif">
      {/* Animated Card */}
      <AnimatePresence mode="wait">
        <motion.div
          key={testimonials[currentIndex].id}
          initial={{ opacity: 0, x: direction > 0 ? 50 : -50 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: direction < 0 ? -50 : 50 }}
          transition={{ duration: 0.4, ease: "easeInOut" }}
          className="w-full flex justify-center"
        >
          <TestimonialCard
            testimonial={testimonials[currentIndex]}
            width="compact"
            themeColor={color}
          />
        </motion.div>
      </AnimatePresence>

      {/* Navigation Dots */}
      <div className="flex justify-center space-x-2 mt-8">
        {testimonials.map((_, index) => (
          <button
            key={index}
            onClick={() => handleDotClick(index)}
            className={`w-2 h-2 rounded-full transition-all duration-200 ${
              index === currentIndex ? "scale-125 shadow" : "opacity-60 hover:opacity-90"
            }`}
            style={{
              backgroundColor: index === currentIndex ? color : "#d1d5db",
            }}
          />
        ))}
      </div>
    </div>
    </div>
  );
};

export default MicrositeTestimonialPreview;
